import { computed, onMounted, onUnmounted, ref } from 'vue'

export const useBreakpoints = () => {
  const windowWidth = ref(window.innerWidth)

  const onWidthChange = () => (windowWidth.value = window.innerWidth)
  onMounted(() => window.addEventListener('resize', onWidthChange))
  onUnmounted(() => window.removeEventListener('resize', onWidthChange))

  const screenType = computed(() => {
    if (windowWidth.value < 550) {
      return 'xs'
    }
    if (windowWidth.value >= 550 && windowWidth.value < 1200) {
      return 'md'
    }
    if (windowWidth.value >= 1200) {
      return 'lg'
    }
    return null
  })

  // const width = computed(() => windowWidth.value)

  return { screenType }
}
